var group = document.querySelectorAll('.parallax-container');
  function parallaxElements(elements, options) {
    var currentSettings = {};
    var listening = false;
    function move() {
      if (currentSettings.disabled) {
        elements.forEach(function(element, ix) {
          var speed = element.dataset.parallaxSpeed.split(',');
          var wrapper = element.querySelector('.parallax-content');
          wrapper.style.transform = '';
        });
        if (listening) {
          window.removeEventListener('scroll', move);
          listening = false;
        }
      } else {
        elements.forEach(function(element, ix) {
          var data = element.getBoundingClientRect();
          var coordTop = data.top;
          var coordBottom = data.top + data.height;
          var diff = (coordTop+coordBottom)/2 - (window.innerHeight/2)
          
          var speed = element.dataset.parallaxSpeed.split(',');
          var speedX, speedY;;
          if (speed.length>1) {
            speedX = speed[0];
            speedY = speed[1];
          } else {
            speedX = 0;
            speedY = speed[0];
          }
          var wrapper = element.querySelector('.parallax-content');
          wrapper.style.transform = 'translate(' + (diff * speedX) + 'px, ' + (diff * speedY) + 'px)';
        });
        if (!listening) {
          window.addEventListener('scroll', move);
          listening = true;
        }
      }
    }

    if (options && options.breakpoints && options.breakpoints.length > 0) {
      var mqs = [];
      for (var breakpoint in options.breakpoints) {
        var mq = window.matchMedia(breakpoint);
        mqs.push(mq);
      }
      var refreshTimeoutId = 0;
      function refresh() {
        clearTimeout(refreshTimeoutId);
        refreshTimeoutId = setTimeout(function(){
          for (var i=0; i<mqs.length; i++) {
            mqs[i].matches;
            currentSettings = options.breakpoints[i];
          }
          move();
        }, 1000);
      }
      refresh();
    } else {
      move();
    }

    setTimeout(function() {
      elements.forEach(function(element) {
        element.classList.add('parallax-initialized')
      })
    }, 1000);
  }
  parallaxElements(group);